<template>
  <svg viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.1501 1.99985C17.1501 2.63498 16.6352 3.14985 16.0001 3.14985H2.0001C1.36497 3.14985 0.850098 2.63498 0.850098 1.99985C0.850098 1.36473 1.36497 0.849854 2.0001 0.849854H16.0001C16.6352 0.849854 17.1501 1.36473 17.1501 1.99985Z"
      fill="#A69EFF"
    />
  </svg>
</template>

<script>
export default {}
</script>
